import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { fanHubOverlineSx, fanHubPaperSx } from "../components/fanHub/fanHubStyles";
import { BRAND_COLORS, brandOutlinedButtonSx } from "../utils/brandAssets";

const Row = ({ label, value }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      gap: 2,
      py: 1.5,
      borderBottom: "1px solid rgba(255,255,255,0.06)",
    }}
  >
    <Typography color="text.secondary">{label}</Typography>
    <Typography fontWeight={600} sx={{ textAlign: "right" }}>
      {value}
    </Typography>
  </Box>
);

const Settings = () => {
  const { user, logout } = useAuth();

  if (!user) {
    return (
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Typography>Sign in to manage your account.</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: { xs: 2, sm: 4 }, mb: 8 }}>
      <Typography variant="overline" sx={fanHubOverlineSx}>
        Account
      </Typography>
      <Typography variant="h4" fontWeight={800} sx={{ mt: 0.5, mb: 1 }}>
        Settings
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3, maxWidth: 440 }}>
        Security and account facts. Teams, follows, and comparisons live on your
        profile.
      </Typography>
      <Box sx={{ ...fanHubPaperSx(BRAND_COLORS.cyan), p: 2.5 }}>
        <Row label="Email" value={user.email} />
        <Row
          label="Account type"
          value={user.provider === "google" ? "Google" : "Email / password"}
        />
        <Row
          label="Member since"
          value={
            user.createdAt
              ? new Date(user.createdAt).toLocaleDateString()
              : "Unknown"
          }
        />
        <Box sx={{ display: "flex", gap: 1, mt: 2.5 }}>
          <Button
            component={RouterLink}
            to="/app/profile"
            variant="outlined"
            sx={brandOutlinedButtonSx}
          >
            Back to profile
          </Button>
          <Button color="error" onClick={logout}>
            Sign out
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Settings;
